// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.current-balance[data-v-3a31f5f4]{\r\n\tbackground:var(--main-gray-1); padding: 6px 12px; color:var(--main-gray-5); border-radius: 3px; border:1px solid var(--main-gray-2);\n}\n.dc-switch[data-v-3a31f5f4]{\r\n\tbackground: #fff; border-color: var(--main-gray-2); color:var(--main-gray-6);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
